<!-- =========================================================================================
    File Name: MailItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="custom-item"
    :class="{ 'mail__opened-mail listitemsmart': false , 'important': isImportant}"
  >
    <!-- MAIL ROW 1 : META -->
    <div class="w-full" :class="{'': isDesktop}" style="display: flow-root;">
      <div class="items-header listviewdetail">
        <div class="item-details mt-2">
          <div class="flex">
            <div class="w-full"><h6 class="mt-2 hat-list">{{chapeu}}</h6></div>
            <!-- <div class="float-right">Importante</div> -->
            
            <div class="badge live" v-if="data.inLive" @click.stop="onFilter('inLive', true)">
              <div class="badge-wrap">
                  <span class="badge-icon badge-view">
                    <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 2.333c2.577 0 4.667 2.09 4.667 4.667S9.577 11.667 7 11.667 2.333 9.577 2.333 7 4.423 2.333 7 2.333zm0 1.05c-1.997 0-3.617 1.62-3.617 3.617 0 1.997 1.62 3.617 3.617 3.617 1.997 0 3.617-1.62 3.617-3.617 0-1.997-1.62-3.617-3.617-3.617z"></path></svg><span class="badge-icon-inner"><svg aria-hidden="true" focusable="false" viewbox="0 0 14 14"><path d="M7 9.567c1.418 0 2.567-1.15 2.567-2.567 0-1.418-1.15-2.567-2.567-2.567-1.418 0-2.567 1.15-2.567 2.567 0 1.418 1.15 2.567 2.567 2.567z"></path>
                    </svg>
                  </span>
                </span>
                <span class="badge-text">{{$t('BADGES').InLive}}</span>
              </div>
            </div>
            <div class="badge bdg-imp" v-if="isImportant && !data.inLive" @click.stop="onFilter('important', true)"><div class="badge-wrap"> <span class="badge-text">{{$t('BADGES').Important}}</span></div></div>
            <div class="badge" v-if="data.exclusive"><div class="badge-wrap" @click.stop="onFilter('exclusive', true)"> <span class="badge-text">{{$t('BADGES').Exclusive}}</span></div></div>
            <div class="badge disclosure-announcement-badge" v-if="isDisclosureAnnouncement" @click.stop="onFilter('disclosureAnnouncement', true)"><div class="badge-wrap"> <span class="badge-text">{{$t("BADGES").Announcement}}</span></div></div>
            <div class="badge disclosure-invite-badge" v-if="isDisclosureInvite" @click.stop="onFilter('disclosureInvite', true)"><div class="badge-wrap"> <span class="badge-text">{{$t("BADGES").Invite}}</span></div></div>
          </div>
          <h3
            class="item-chapeu item-chapeu-list mb-2 mt-2"
            :class="{ 'font-semibold': true }"
          >
            {{ getTitle }}
          </h3>
          <div
            class="sub-text"
            v-if="data.content.abstract.data"
          >
            {{ data.content.abstract.data }}
          </div>
          
          <div class="img-bg-post mt-3" :style="getThumbPathStyle" v-if="thumbPath"></div>
          <div class="autorline flex">
            <author-info v-if="data.author" :displayNickname="true" class="author cursor-pointer w-full mt-3 mb-3 flex author-high" :author="data.author" @open-author="$emit('open-author', $event)"></author-info>
          </div>
          <div class="tags-card  w-full tagsitem mb-3 flex" v-if="badgeContentType || (data.tags && data.tags.length > 0)">
            <template v-if="isDesktop">
              <div class="filter-chip-card px-1 mr-1 mb-1" v-for="(tags, index) in data.tags" :key="index" @click.stop="onFilter('searchQuery', tags.name)">{{tags.name}}</div>
            </template>
            <template v-else> 
              <!-- TAGS -->
                <div class="filter-chip-card px-1 mr-1 mb-1" v-for="(tags, index) in data.tags" :key="index" @click.stop="onFilter('searchQuery', tags.name)">{{tags.name}}</div>
            </template>

          </div>
          <!-- <div>
            <template v-if="isAuthenticated">
              <span class="mr-1" v-if="!isItemNews">{{ formatDate(data.dt_publish, {dateStyle: "short"}) }}</span> 
              <span class="mr-1" v-if="isItemNews">{{ data.dt_publish | moment("from") }}</span>

              <span class="item-date bold"> — em {{
                getSubjectName(data.subjects)
              }}</span>
              <span class="cursor-pointer link" @click.stop="$emit('open-author', data.author)"> — por {{data.author.name}}</span>
            </template>
            
          </div> -->
          
          
          <!-- Avatar -->
          
          <!-- End of Avatar -->
        </div>

      </div>

      <div class="card-f w-full" >

      </div>

        
        <!-- <div class="flex float-right" v-if="isAuthenticated && data.displayDetail"> -->
        <div class="tags-card" :class="{'': isDesktop}">
          <template v-if="!isAuthenticated">
            <div class="item-date" v-if="!isReport && canDisplayDateField">{{ formatDate(data.dt_publish, { dateStyle: "short" }) }}</div>
            <div class="item-date" v-if="isReport && canDisplayDateField">{{ formatFullDate(data.dt_report, {dateStyle: "short"}) }}</div>
          </template>
          <template v-else>
            <span class="item-date" v-if="!isReport && canDisplayDateField">{{ formatDate(data.dt_publish, { dateStyle: "short" }) }}</span> 
            <span class="item-date" v-if="isReport && canDisplayDateField">{{ formatFullDate(data.dt_report, {dateStyle: "short"}) }}</span>  
          </template>
          
          <span class="item-date bold cursor-pointer link" @click.stop="navigateToSubject"> <span v-if="canDisplayDateField"> — </span>  {{ $t('VIEW_MODES').In }} {{
            getSubjectName(data.subjects)
          }}</span>
          
          
          
        </div>
        
              
    <!-- /MAIL ROW 1 -->
  </div>
  <div class="flex float-right actions-bar">
    <div class="flex actions-bar-card">
      <action-icons-field 
        :data="data" 
        :isAuthenticated="isAuthenticated" 
        :isDesktop="isDesktop"
        @addPlaylist="addPlaylist"
        @playMultimedia="playMultimedia"
        @onDownloadFile="onDownloadDocument"
        @open-exclusive-content="$emit('open-exclusive-content')"
        @save-schedule-news="$emit('save-schedule-news', data)">
      </action-icons-field>
    </div>
  </div>
  <!-- <div class="flex icons-details items-center" v-if="!data.displayDetail">
    <vx-tooltip text="Conteúdo exclusivo" delay=".1s"><span  class="iconsafra"><feather-icon @click.stop="$emit('open-exclusive-content')" icon="LockIcon" class="mr-0" :svgClasses="['icon-Volume']"/></span></vx-tooltip>
  </div> -->
</div>
</template>

<script>
import DropdownUserInfo from "../widgets/dropdown-user-info/DropdownUserInfo.vue";
import AppConstants from "../../../appConstants";
import { CONTENT } from "../../../enums/enum-content";
import Popper from "vue-popperjs";
import convertDatetimeHelper from '../../../helpers/convert-datetime-helper';
import GeneralHelper from '../../../helpers/general-helper';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VxTooltip from '../../../layouts/components/vx-tooltip/VxTooltip.vue';
import translateFieldHelper from '../../../helpers/translate-field-helper';
import InformativePreviewData from './InformativePreviewData.vue';
import formatFieldHelper from '../../../helpers/format-field-helper';
import AuthorInfo from '../../../layouts/components/customizer/AuthorInfo.vue';
import generalHelper from '../../../helpers/general-helper';
import { EventBus } from '../../../event-bus';
import ActionIconsField from '../../../layouts/components/customizer/ActionIconsField.vue';

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    isDesktop: {
      type: Boolean,
      required: true
    },
    contentId: {
      require: true
    },
    currentCommodity: {
      require: true
    },
    isAuthenticated: {
      require: true
    },
  },
  data() {
    return {
      publisherVisible: false,
      thumbPath: '',
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.5
      },
    };
  },
  async created() {
    await this.getThumbPath();
  },
  watch: {},
  computed: {
    canDisplayDateField() {
      return (
        this.data.newsContent.findIndex(
          item =>
            item.code != CONTENT.CONSULTING_COURSES
        ) >= 0
      );
    },
    isReport() {
      return (
        this.data.newsContent.findIndex(
          item =>
            item.code == CONTENT.INFORMATIVE ||
            item.code == CONTENT.EXPORTS ||
            item.code == CONTENT.STATISTIC
        ) >= 0
      );
    },
    getTitle() {
      if (!this.data) return '';
      if (this.data.newsContent[0].code == CONTENT.STATISTIC ||
        this.data.newsContent[0].code == CONTENT.EXPORTS ||
        this.data.newsContent[0].code == CONTENT.INFORMATIVE) {
          return translateFieldHelper.getTranslateField('name', this.data.reportType);
        }
      return this.data.content.title.data;
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    displayPadlock() {
      return this.AppActiveUser.profile == AppConstants.USER_PROFILE.FREE;
    },
    isListView() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW
      );
    },
    isListViewDetailed() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
    },
    soundCloudLink() {
      return `${AppConstants.URL_SOUNDCLOUD_EMBED}${this.data.soundcloud}&show_teaser=false`;
    },
    audioLink() {
      return this.data.audio.image_path;
    },
    audioType() {
      if (this.data.audio) {
        return `audio/${this.data.audio.extension}`;
      }
      return "";
    },
    badgeContentTypeIconClass() {
      const c = "h-3 w-3";
      if (this.data.document) return `${c} badge-content-blue`;
      if (this.data.audio || this.data.soundcloud)
        return `${c} badge-content-purple`;
      if (this.data.youtubeId) return `${c} badge-content-red`;
      return c;
    },
    youtubeLink() {
      return `${AppConstants.URL_YOUTUBE_EMBED}${
        this.data.youtubeId
      }?iv_load_policy=3&modestbranding=0&playsinline=1&showinfo=0&rel=0&enablejsapi=1`;
    },
    badgeTypeClass() {
      if (this.data.document) return "attach-document";
      if (this.data.audio) return "audio";
      if (this.data.youtubeId) return "video";
      if (this.data.soundcloud) return "podcast";
      if (this.data.spotify) return "podcast";
      return "";
    },
    badgeContentType() {
      if (this.data.document) return "Anexo";
      if (this.data.audio) return "Audio";
      if (this.data.youtubeId) return "Video";
      if (this.data.soundcloud) return "Podcast";
      if (this.data.spotify) return "Podcast";
      return "";
    },
    badgeContentTypeIcon() {
      if (this.data.document) return "PaperclipIcon";
      if (this.data.audio) return "VoicemailIcon";
      if (this.data.youtubeId) return "PlayIcon";
      if (this.data.soundcloud) return "MicIcon";
      if (this.data.spotify) return "MicIcon";
      return "";
    },
    hatName() {
      if (this.data.hat[0]) {
        return this.data.hat[0].name.toUpperCase();
      }
      return this.data.newsContent[0][`name${this.$i18n.locale}`];
    },
    canDisplayPreview() {
      return (
        this.isDesktop &&
        (this.data.newsContent[0].code == CONTENT.NEWS ||
          this.data.newsContent[0].code == CONTENT.CONSULTING ||
          this.data.newsContent[0].code == CONTENT.STATISTIC ||
          this.data.newsContent[0].code == CONTENT.EXPORTS ||
          this.data.newsContent[0].code == CONTENT.CONSULTING_SAFRAS_TV ||
          this.data.newsContent[0].code == CONTENT.CONSULTING_COURSES ||
          this.data.newsContent[0].code == CONTENT.CONSULTING_SPEECHES ||
          this.data.newsContent[0].code == CONTENT.CONSULTING_EXCHANGE ||
          this.data.newsContent[0].code == CONTENT.WEATHER)
      );
    },
    canAddPlaylist() {
      return (
        this.hasYoutube ||
        this.hasAudio ||
        this.hasSpotify ||
        this.hasSoundCloud
      ) && this.isAuthenticated;
    },
    hasMultimedia() {
      return (this.hasAudio || this.hasYoutube || this.hasSoundCloud || this.hasSpotify);
    },
    isItemNews() {
      return this.contentId == CONTENT.NEWS;
    },
    chapeu() {
      if (this.data) {
        if (this.data.hat[0]) {
          return this.data.hat[0].name.toUpperCase();
        }
      }
      return "";
    },
    hasDocument() {
      return !!this.data.document;
    },
    hasAudio() {
      return !!this.data.audio;
    },
    hasYoutube() {
      return !!this.data.youtubeId;
    },
    hasSpotify() {
      return !!this.data.spotify;
    },
    hasSoundCloud() {
      return !!this.data.soundcloud;
    },
    hasImageUrl() {
      return !!this.data.image;
    },
    isImportant() {
      return this.data.importance > 0;
    },
    isDisclosureAnnouncement() {
      return this.data.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.ANNOUNCEMENT;
    },
    isDisclosureInvite() {
      return this.data.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.INVITE;
    },
    // publisherContent(report) {
    //   return data.nome_usuario;
    // }
    featherIconSize() {
      if (this.isDesktop) {
        return "h-4 w-4";
      } else {
        return "h-6 w-6";
      }
    },
    getIcon() {
      if (this.hasYoutube) {
        return "VideoIcon";
      } else if (this.hasAudio || this.hasSoundCloud) {
        return "MicIcon";
      } else if (this.hasImageUrl) {
        return "PaperclipIcon";
      } else {
        return null;
      }
    },
    hasTextToSpeech() {
      if ( (this.data.content.abstract || this.data.content.text) && !this.hasDocument && this.isDesktop ) {
        return `${this.getTitle} ${
          this.data.content.abstract.data
        } ${this.data.content.text.data}`;
      }
      return false;
    },
    canSpeechText() {
      return generalHelper.canSpeechText(this.data, this.isDesktop);
    },
    headerStyle() {
      try {
        let commodityFile = '';
        let originCode = formatFieldHelper.getOriginCode(this.AppActiveUser);
        if (this.currentCommodity.id && this.currentCommodity.id > 0) {
          commodityFile = require(`../../../assets/images/commodity/${originCode}/${this.currentCommodity.id}.png`);
        } else {
          commodityFile = require(`../../../assets/images/commodity/${originCode}/${this.data.subjects[0].code}.png`);
        }
        return `background-image: url("${commodityFile}");`;
      } catch (e) {
        console.log(e);
        return "";
      }
    },
    getThumbPathStyle() {
      if (this.thumbPath) {
        return `background-image:url('${this.thumbPath}')`;
      }
      return '';
    },
  },
  methods: {
    filterByBadgeContentType(contentType) {
      switch (contentType) {
        case "Anexo":
          this.onFilter('attachment', true);
          break;
        case "Video":
          this.onFilter('video', true);
          break;
        case "Audio":
          this.onFilter('audio', true);
          break;
        case "Podcast":
          this.onFilter('podcast', true);
          break;
      }
    },
    onFilter(field, val) {
      // console.log("onFilter", { field: field, value: val });
      this.$emit("filter", { field: field, value: val });
    },
    onDownloadDocument(data) {
      this.$emit("onDownloadFile", data);
    },
    getIconCard() {
      if (this.hasYoutube) {
        return "VideoIcon";
      } else if (
        this.hasAudio ||
        this.hasSoundCloud ||
        this.hasSpotify
      ) {
        return "MicIcon";
      } else if (this.hasDocument) {
        return "PaperclipIcon";
      } else {
        return null;
      }
    },
    async getThumbPath() {
      // this.thumbPath = require("@/assets/images/informative/placeholder115.svg");
      if (this.data && this.data.thumb) {
        const exist = await GeneralHelper.checkImageExist(this.data.thumb.image_path);
        if (exist) {
          this.thumbPath = this.data.thumb.image_path;
        }
      }
    },
    formatFullDate(val, obj) {
      return convertDatetimeHelper.formatFullDate(val, obj);
    },
    formatDate(val, obj) {
      return convertDatetimeHelper.formatDate(val, obj);
    },
    openDetail() {
      this.$emit("openDetail", this.data);
    },
    navigateToSubject() {
      // console.log('navigateToSubject');
      const subject = translateFieldHelper.getSubjectData(this.data.subjects, this.currentCommodity);
      EventBus.$emit(AppConstants.BUS_EVENT_NAVIGATE_SUBJECT, subject.code);
    },
    getSubjectName(subjects) {
      return translateFieldHelper.getSubjectName(subjects, this.currentCommodity);
    },
    getSubjectIcon(subjects) {
      if (this.currentCommodity.id) {
        const sub = subjects.find(
          item => item.code == this.currentCommodity.id
        );
        if (sub) {
          return sub.icon;
        }
      }
      return subjects[0].icon;
    },
    addPlaylist(data) {
      // alert(`add playlist: ${this.data._id}`);
      // console.log(`add playlist: ${this.data._id}`);
      this.$store.dispatch("insertItemPlaylist", data);
    },
    isReportDateToday() {
      return this.data.data_object.getUTCDate() == new Date().getUTCDate();
    },
    playMultimedia({data, isTextSpeech}) {
      this.$emit("playMultimedia", {
        data: data,
        isTextSpeech: isTextSpeech
      });
      // EventBus.$emit(AppConstants.BUS_EVENT_OPEN_PLAYLIST, true);

    }
  },
  components: {
    DropdownUserInfo,
    popper: Popper,
    VuePerfectScrollbar,
    VxTooltip,
    InformativePreviewData,
    AuthorInfo,
    ActionIconsField
  }
};
</script>

<style lang="scss" scoped>
.item-commodity-icon {
  margin-right: 15px;
}

.custom-item {
  padding-top: 0px;
  padding-bottom: 5px;
  background-color: #ffffff;
  border-radius: 6px;
  width: 100%;
}
.theme-dark .custom-item {
  background-color: #2f363d;
}

.custom-item .card-img {
  width: 100%;
  
  background-position-x: 10px;
  // height: 230px;
  background-repeat: no-repeat;
}

.custom-item:hover {
  transform: none !important;
}

.item-commodity {
  text-transform: none !important;
  font-weight: 600;
  color: #2c2c2c;
}


.item-avatar {
  margin-top: -6px;
  /*position: absolute;*/
  /*margin-left: 10px;*/
  float: left;
}

.item-right {
  height: 60px;
}

.item-date {
  margin-bottom: 25px;
}

.chips {
  margin-top: 10px;
  margin-bottom: 10px;
}

.item-details {
  @media (max-width: 576px){
    // padding-left: 10px;
    // padding-right: 10px;
  }
  // min-width: 370px;
}

.exact-fit {
  word-wrap: break-word;
  width: 400px;
}
.item-date-report {
  right: 10px;
  position: absolute;
  margin-top: -5px;
}
.item-atualizado {
  position: relative;
  top: 55px;
  margin-right: -5px;
}
.play-icon-chip {
  margin-top: -13px;
}

.badge {
  display: inline-block;
  padding: 2px 6px;
  color: #fff;
  background: #e41505;
  border-radius: 4px;
  float: right;
  margin-top: 5px;
  margin-right: 5px;
  height: 18px;
  width: max-content !important;
}
.badge-wrap {
  display: flex;
  align-items: center;
}
.badge-icon {
  position: relative;
  display: inline-flex;
  margin-right: 2px;
}
.badge-icon-inner {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  will-change: opacity;
  -webkit-animation: ani-breath 1.8s ease infinite;
          animation: ani-breath 1.8s ease infinite;
}
.badge-icon svg {
  fill: currentColor;
}
.badge-text {
  display: inline-flex;
  font-size: 10px;
  line-height: 14px;
  text-transform: uppercase;
}

.badge {
  display: inline-block;
  padding: 2px 6px;
  color: #fff;
  background: #e41505;
  border-radius: 4px;
  float: right;
  margin-top: 5px;
  margin-right: 5px;
  height: 18px;
  width: max-content !important;
}
.badge-wrap {
  display: flex;
  align-items: center;
}
.badge-icon {
  position: relative;
  display: inline-flex;
  margin-right: 2px;
}
.badge-icon-inner {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  will-change: opacity;
  -webkit-animation: ani-breath 1.8s ease infinite;
          animation: ani-breath 1.8s ease infinite;
}
.badge-icon svg {
  fill: currentColor;
}
.badge-text {
  display: inline-flex;
  font-size: 10px;
  line-height: 14px;
  text-transform: uppercase;
}

@-webkit-keyframes ani-breath {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}

@keyframes ani-breath {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.live-view {
    background-color: #e41505;
    border: 1px solid #910f05;
    display: inline-table;
    color: #FFF;
    border-radius: 5px;
    padding-left: 25px !important;
    padding: 2px 5px;
    font-size: 13px;
    line-height: 18px;
}


.badge.float-left {
    margin-top: 1px;
}
</style>
